<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <template v-if="loading && !displayedRows.length">
      <div
        :class="b('columns', { application: isApplication })"
        v-if="!isApplication"
      >
        <div
          v-for="column in displayedColumns"
          :key="column.id"
          :class="b('column')"
        >
          <p :class="b('column-label')">{{ $t(column.label) }}</p>
        </div>
      </div>

      <div :class="b('skeletons')" aria-hidden="true">
        <template v-if="isApplication">
          <div v-for="index in 2" :key="index" :class="b('skeleton-deal')">
            <div :class="b('skeleton-deal-date')">
              <span :class="b('bar')" style="width: 84%; height: 13px"></span>
              <span
                :class="b('bar')"
                style="width: 62%; height: 10px; margin-top: 6px"
              ></span>
            </div>

            <div :class="b('skeleton-deal-main')">
              <span :class="b('bar')" style="width: 44%; height: 16px"></span>
              <span :class="b('bar')" style="width: 82%; height: 16px"></span>

              <div :class="b('skeleton-stage')">
                <span :class="b('bar')" style="width: 30%; height: 10px"></span>
                <span :class="b('bar')" style="width: 68%; height: 10px"></span>
              </div>
            </div>

            <span :class="b('skeleton-pill')"></span>
          </div>
        </template>

        <template v-else>
          <div v-for="index in 4" :key="index" :class="b('skeleton-row')">
            <span
              v-for="(width, i) in displayedSkeletonBarWidths"
              :key="i"
              :class="b('bar')"
              :style="{ width }"
            ></span>
          </div>
        </template>
      </div>
    </template>

    <template v-else-if="displayedRows.length">
      <div :class="b('columns')" v-if="!isApplication">
        <div
          v-for="column in displayedColumns"
          :key="column.id"
          :class="b('column')"
        >
          <p :class="b('column-label')">{{ $t(column.label) }}</p>
        </div>
      </div>

      <div :class="b('rows', { application: isApplication })">
        <component
          v-for="row in displayedRows"
          :key="rowKey(row)"
          :is="displayedRow"
          :class="b('row')"
          :row="(row as any)"
          @depositWithdrawal="handleDepositWithdrawal"
          @remove="handleRemove"
          @application="handleApplication"
        />
      </div>

      <div :class="b('footer')">
        <span :class="b('count')">
          {{ $t("Показано") }} <b>{{ displayedRows.length }}</b>
          {{ $t(isApplication ? "заявок" : "операций") }}
        </span>

        <button
          v-if="hasMoreItems"
          :class="b('show-more')"
          :disabled="loading"
          @click="handleShowMore"
        >
          <span>{{ $t("Показать еще") }}</span>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 5v13m-5-5 5 5 5-5" />
          </svg>
        </button>
      </div>
    </template>

    <div v-else :class="b('empty')">
      <div :class="b('empty-orb')">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect x="4" y="3" width="16" height="18" rx="3" />
          <path d="M8 9h8M8 13h5" />
        </svg>
      </div>
      <h3>
        {{ $t(isApplication ? "Заявок не найдено" : "Ничего не найдено") }}
      </h3>
      <p>{{ $t("Измените поисковый запрос или сбросьте фильтры.") }}</p>
    </div>
  </div>
</template>
